__turbopack_context__.v({
  "btn": "bf_TZG_btn",
  "btn--dark": "bf_TZG_btn--dark",
  "btn--overlay": "bf_TZG_btn--overlay",
});
